// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .settings-container {
    max-width: 600px;
    margin: 100px auto 60px auto;
    background: var(--bg-100);
    padding: 30px;
  } */
  
  .settings-section {
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid var(--bg-200);
  }
  
  .settings-section h3 {
    margin-bottom: 15px;
    color: var(--primary-200);
  }
  
  .settings-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }
  
  .settings-item select {
    padding: 6px 10px;
    border-radius: 8px;
    border: 1px solid var(--bg-200);
  }
  
  .settings-checkbox {
    margin-bottom: 10px;
  }
  
  .save-btn {
    background: var(--primary-200);
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 10px;
    cursor: pointer;
  }
  
  .save-btn:hover {
    background: var(--primary-100);
  }
  
  .danger-zone {
    border-bottom: none;
  }
  
  .delete-account-btn {
    background: #d32f2f;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 8px;
    cursor: pointer;
  }
  `, "",{"version":3,"sources":["webpack://./src/componentsL/Settings.css"],"names":[],"mappings":"AAAA;;;;;KAKK;;EAEH;IACE,mBAAmB;IACnB,oBAAoB;IACpB,sCAAsC;EACxC;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB","sourcesContent":["/* .settings-container {\n    max-width: 600px;\n    margin: 100px auto 60px auto;\n    background: var(--bg-100);\n    padding: 30px;\n  } */\n  \n  .settings-section {\n    margin-bottom: 30px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid var(--bg-200);\n  }\n  \n  .settings-section h3 {\n    margin-bottom: 15px;\n    color: var(--primary-200);\n  }\n  \n  .settings-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 15px;\n  }\n  \n  .settings-item select {\n    padding: 6px 10px;\n    border-radius: 8px;\n    border: 1px solid var(--bg-200);\n  }\n  \n  .settings-checkbox {\n    margin-bottom: 10px;\n  }\n  \n  .save-btn {\n    background: var(--primary-200);\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 10px;\n    cursor: pointer;\n  }\n  \n  .save-btn:hover {\n    background: var(--primary-100);\n  }\n  \n  .danger-zone {\n    border-bottom: none;\n  }\n  \n  .delete-account-btn {\n    background: #d32f2f;\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 8px;\n    cursor: pointer;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
